import { render, staticRenderFns } from "./SimProjectDetail.vue?vue&type=template&id=f8f2633c&scoped=true"
import script from "./SimProjectDetail.vue?vue&type=script&lang=js"
export * from "./SimProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./SimProjectDetail.vue?vue&type=style&index=0&id=f8f2633c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f2633c",
  null
  
)

export default component.exports